<div class="lsq-input lsq-search" [ngClass]="{ 'large-inline': largeInlineStyling }">
    <lsq-input
        #inputElement
        [name]="name"
        [label]="label"
        [control]="getControl()"
        [group]="group"
        [inputValue]="searchText"
        [basicLabel]="basicLabel"
        [floatLabel]="floatLabel"
        [innerLabel]="innerLabel"
        [parentClass]="parentClass"
        [inputClass]="inputClass"
        [labelClass]="labelClass"
        [autoFocus]="autoFocus"
        [placeholder]="placeholder ? placeholder : ''"
        [hideInputElement]="!!selectedResult && !isFocused"
        [preventControlUpdate]="true"
        (keyDownEvent)="handleViewportKeypress($event)"
        (inputValueChanged)="handleInputValueChanged($event)"
        (focus)="handleFocusChange(true)"
        (blur)="handleFocusChange(false)"
    >
        <ng-template #inputGroupPrepend>
            <span class="input-group-prepend" *ngIf="!largeInlineStyling">
                <lsq-icon
                    [type]="icons.FaMagnifyingGlassSolid"
                    [color]="!showErrorMessage() ? color.GraphicGray : color.Red"
                ></lsq-icon>
            </span>
        </ng-template>

        <ng-template #dropdownViewport>
            <lsq-dropdown [show]="results && results.length > 0" [triangle]="false">
                <ng-scrollbar #scrollBarRef>
                    <ul class="lsq-dropdown-list list-unstyled" #dropdownMenuRef>
                        <li
                            #optionRefs
                            *ngFor="let result of results; let i = index"
                            [ngClass]="{
                                selected: i === highlightedOptionIndex,
                                ineligible: result.isNoBuy && !allowIneligible,
                                'allow-ineligible': result.isNoBuy && allowIneligible
                            }"
                            class="lsq-dropdown-item dropdown-item"
                            (mousedown)="
                                allowIneligible || !result.isNoBuy ? selectItem(result) : null
                            "
                        >
                            <!-- NEW BRAND -->
                            <!-- <p class="text-white">
                                {{ result[primaryDisplayKey] }}
                                <lsq-ineligible-tag *ngIf="result.isNoBuy"></lsq-ineligible-tag>
                            </p> -->
                            <p>
                                <strong [style.margin-right]="'0.5rem'">{{
                                    result[primaryDisplayKey]
                                }}</strong>
                                <lsq-ineligible-tag *ngIf="result.isNoBuy"></lsq-ineligible-tag>
                            </p>
                            <p *ngIf="result[secondaryDisplayKey] && isSecondaryDataAddress">
                                <lsq-address
                                    [address]="result[secondaryDisplayKey]"
                                    [singleLine]="true"
                                ></lsq-address>
                            </p>
                            <p *ngIf="result[secondaryDisplayKey] && !isSecondaryDataAddress">
                                {{ result[secondaryDisplayKey] }}
                            </p>
                            <p
                                *ngIf="
                                    !result[secondaryDisplayKey] &&
                                    !isSecondaryDataAddress &&
                                    !!secondaryDisplayMethod
                                "
                            >
                                {{ secondaryDisplayMethod(result) }}
                            </p>
                        </li>
                    </ul>
                </ng-scrollbar>
            </lsq-dropdown>
        </ng-template>

        <ng-template #inputGroupAppend>
            <lsq-button-spinner
                [isBlackSpinner]="true"
                *ngIf="isLoadingResults && isFocused"
            ></lsq-button-spinner>

            <span
                #searchClose
                class="lsq-search-close"
                *ngIf="isFocused && (showClearIcon || selectedResult || alwaysShowClose)"
                (mousedown)="clearSearchAndValue()"
            >
                <lsq-icon [type]="icons.CloseSmall" [color]="color.Black"></lsq-icon>
            </span>

            <span
                #resultCard
                *ngIf="selectedResult && !isFocused"
                class="form-control lsq-search-selected-card"
                (mouseup)="openInput($event)"
            >
                <div
                    class="selected-card-container"
                    [ngClass]="{ 'small-result-text': smallTextForResults }"
                >
                    <!-- NEW BRAND -->
                    <p class="text-truncate">
                        <strong>{{ selectedResult[primaryDisplayKey] }}</strong>
                    </p>
                    <p *ngIf="selectedResult[secondaryDisplayKey] && isSecondaryDataAddress">
                        <lsq-address
                            [address]="selectedResult[secondaryDisplayKey]"
                            [singleLine]="true"
                            [truncate]="true"
                        >
                        </lsq-address>
                    </p>
                    <p *ngIf="selectedResult[secondaryDisplayKey] && !isSecondaryDataAddress">
                        {{ selectedResult[secondaryDisplayKey] }}
                    </p>
                    <p
                        *ngIf="
                            !selectedResult[secondaryDisplayKey] &&
                            !isSecondaryDataAddress &&
                            !!secondaryDisplayMethod
                        "
                    >
                        {{ secondaryDisplayMethod(selectedResult) }}
                    </p>
                </div>
            </span>
        </ng-template>
    </lsq-input>
</div>
